<ng-container *ngIf="showCollapse; else content">
  <div
    (click)="onContainerClick()"
    class="text-collapse-more"
    [ngClass]="{ 'text-collapse-disable': !collapsed }"
    [ngStyle]="{
      '-webkit-line-clamp': 2,
      display: collapsed ? 'flex' : 'block'
    }"
  >
    <div [ngClass]="{ 'collapse-text-container': collapsed }">
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <a *ngIf="!collapsed" class="link less">...less</a>
    </div>
    <a *ngIf="collapsed" class="link more">...more</a>
  </div>
</ng-container>
<ng-template #content>
  <div
    [ngStyle]="{
      overflow: showCollapse ? 'inherit' : 'auto',
      'white-space': showCollapse ? 'inherit' : 'nowrap',
      'word-break': showCollapse ? 'break-all' : 'unset'
    }"
  >
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</ng-template>
<div
  #scaleContainer
  style="
    overflow: auto;
    white-space: nowrap;
    height: 0;
    visibility: hidden;
    word-break: unset;
  "
>
  <ng-container *ngIf="contentTemplate">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ng-container>
</div>

<ng-template pTemplate="content" #contentTemplate>
  {{ textToShow }}
</ng-template>
